// removed by extract-text-webpack-plugin
module.exports = {"root":"_1SCf9CS","heading":"_2vZKwQd","paragraph":"_3qzxQYj"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/ResultsError/ResultsError.less
 ** module id = 830
 ** module chunks = 0
 **/